// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tbody.tariff-table-body > tr:nth-child(even) > td {
  background-color: #F4F4F4;
}

tbody.tariff-table-body > tr:nth-child(odd) > td {
  background-color: white;
}

.tariff-table-header th {
  background-color: #004B22;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/style/tariffTable.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,WAAA;AACJ","sourcesContent":["tbody.tariff-table-body > tr:nth-child(even) > td {\n    background-color: #F4F4F4;\n}\n\ntbody.tariff-table-body > tr:nth-child(odd) > td {\n    background-color: white;\n}\n\n.tariff-table-header th {\n    background-color: #004B22;\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
